import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../../common/Fieldset";
import Row from "../../../common/Row";
import TextInput from "../../../common/TextInput";
import ValidationGroup from "../../../common/ValidationGroup";

const SocialeMedia = (props) => {
    const {
        model,
        getError,
        onChange,
        disabled,
        validationMessageType
    } = props;

    const mapChange = (mask) => {
        return function (event) { onChange(event, mask); };
    };

    const urlError = getError("publicatieUrlRequired") ?? null;

    return <Fieldset title="Digitale kanalen">
        <Row>
            <p className="o-col-12">Tochten kunnen alleen gepubliceerd worden op UiT in Vlaanderen als je jouw website of facebook ingevuld hebt.</p>
            &nbsp;
        </Row>
        <Row>
            <ValidationGroup messages={urlError ? urlError : undefined}>
                <TextInput
                    name="website"
                    label="Website"
                    value={model.website}
                    onChange={mapChange("http://")}
                    optional={(model.facebook && model.facebook !== "http://www.facebook.com/") || model.publicatieOpWebsiteUitInVlaanderen === false}
                    disabled={disabled}
                    validationMessage={getError('website')}
                    validationMessageType={validationMessageType}
                    size={6}
                    inputmask="http://"
                />
                <TextInput
                    name="facebook"
                    label="Facebook"
                    value={model.facebook}
                    onChange={mapChange("https://www.facebook.com/")}
                    optional={(model.website && model.website !== "http://") || model.publicatieOpWebsiteUitInVlaanderen === false}
                    disabled={disabled}
                    validationMessage={getError('facebook')}
                    validationMessageType={validationMessageType}
                    size={6}
                    inputmask="https://www.facebook.com/"
                />
            </ValidationGroup>
        </Row>
        <Row>
            <TextInput
                name="instagram"
                label="Instagram"
                value={model.instagram}
                onChange={mapChange("https://www.instagram.com/")}
                validationMessage={getError('instagram')}
                validationMessageType={validationMessageType}
                disabled={disabled}
                size={6}
                optional
                inputmask="https://www.instagram.com/"
            />
        </Row>
    </Fieldset>;
};

SocialeMedia.propTypes = {
    model: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    getError: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    validationMessageType: PropTypes.string
};

export default SocialeMedia;